import React from 'react';
import { feedbackLoop } from '../data/site';
export function FeedbackProcess() {
  return <section id="feedback" className="border-t border-ink/10 bg-cream py-20 md:py-28" data-id="element-28" data-mp="37c8wi0l0bjye">
      <div className="mx-auto max-w-content px-5 md:px-8 lg:px-10" data-id="element-29" data-mp="32lsj2gh6ryc1">
        <div className="mx-auto max-w-2xl text-center" data-id="element-30" data-mp="32jxvsvifzu4s">
          <h2 className="font-display text-[32px] font-semibold leading-[1.12] tracking-[-0.02em] text-ink md:text-[44px]" data-id="element-31" data-mp="2xnqwvmogriwc">
            Listen. Learn. Improve.
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-[17px] leading-relaxed text-ink/70" data-id="element-32" data-mp="2np1elssnnwfk">
            Feedback informs direction. Not every request becomes a feature — every pattern gets
            looked at.
          </p>
        </div>

        <ol className="mt-16 grid grid-cols-1 gap-px border border-ink/15 bg-ink/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-33" data-mp="2epepa5d7ah2v">
          {feedbackLoop.map(step => <li key={step.number} className="relative bg-cream px-6 py-10 md:px-8" data-id="element-34" data-mp="cwzz6j0i66bd">
              <span className="absolute inset-x-0 top-0 h-[3px] bg-violet" aria-hidden="true" data-id="element-35" data-mp="lmheukwmno6q" />
              <span className="text-[12px] font-medium tracking-[0.18em] text-violet" data-id="element-36" data-mp="qm3t8xo6zah4">
                {step.number}
              </span>
              <h3 className="mt-4 font-display text-[24px] font-medium leading-tight text-ink" data-id="element-37" data-mp="cnx363phies0">
                {step.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-ink/70" data-id="element-38" data-mp="15a845fh06hpc">{step.detail}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}